// Change active thumbnail on scroll
const thumbs = document.querySelectorAll('.product__media-thumbnail-item');

window.addEventListener('scroll', (event) => {
  const fromTop = window.scrollY;
  const navHeight = document.querySelector('.outer-header-wrapper').clientHeight;

  if(!thumbs) return
    thumbs.forEach(thumb => {
    const section = document.querySelector(`.product__media-item[data-media-id="${thumb.dataset.mediaId}"]`);

      if (section) {
        if (section.offsetTop <= fromTop && section.offsetTop + section.clientHeight > fromTop) {
          thumb.classList.add('active');
        } else {
          thumb.classList.remove('active');
        }
      }
    });
});

// Scroll to image on thumbnail click
if(thumbs) {
thumbs.forEach(thumb => {
  thumb.addEventListener('click', event => {
    event.preventDefault();
    const section = document.querySelector(`.product__media-item[data-media-id="${event.currentTarget.dataset.mediaId}"]`);

    window.scrollTo({
      top: section.offsetTop,
      behavior: "smooth"
    });
  });
});
}

// Product zoom slider
const productZoom = new Swiper(document.querySelector('.product__media-carousel'), {
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
})

// Product mobile slider
const productSlider = document.querySelector('.product__media-list');
let productSliderInstance = {};
const settingsSlider = {
  loop: true,
  pagination: {
    el: '.product__media-pagination',
    clickable: true
  }
}

const quickViewSettingsSlider = {
  loop: true,
  // pagination: {
  //   el: '.product__media-pagination',
  //   clickable: true
  // },
  // draggable: true,
  navigation: {
    prevEl: '.product__media-button-prev',
    nextEl: '.product__media-button-next'
  },
}

// Product mobile slider
const productUpsellSlider = document.querySelector('.product__upsells-swiper');
let productUpsellSliderInstance = {};
const productUpsellSettingsSlider = {
  loop: false,
  slidesPerView: 'auto',
  spaceBetween: 10,
  navigation: {
    prevEl: '.upsell-arrow-left',
    nextEl: '.upsell-arrow-right'
  },
  breakpoints: {
    501: {
      slidesPerView: 2,
    }
  }
}

window.addEventListener('load', pdpSwiperOnLoadOrResize);
window.addEventListener('resize', pdpSwiperOnLoadOrResize);

function pdpSwiperOnLoadOrResize() {

  if(productSlider) {
    if(productSlider.closest("quick-view")) {
      if (!productSlider.classList.contains('swiper-initialized')) {
        productSliderInstance = new Swiper('.product__media-list', quickViewSettingsSlider);
      }
    } else if (window.innerWidth > 768) {
      if (productSlider.classList.contains('swiper-initialized')) {
        productSliderInstance.destroy({
          deleteInstance: true,
          cleanStyles: true
        });
      }
    } else {
      if (!productSlider.classList.contains('swiper-initialized')) {
        productSliderInstance = new Swiper('.product__media-list', settingsSlider);
      }
    }
  }

  if(productUpsellSlider != undefined) {
    if(window.innerWidth > 500) {
      if (productUpsellSlider.classList.contains('swiper-initialized')) {
        productUpsellSliderInstance.destroy({
          deleteInstance: true,
          cleanStyles: true
        });
      }
    } else {
      if (!productUpsellSlider.classList.contains('swiper-initialized')) {
        productUpsellSliderInstance = new Swiper(productUpsellSlider, productUpsellSettingsSlider);
      }
    }
  }
}

// Assign sticky position to thumbnails based on header height
const thumbnails = document.querySelector('.product__media-thumbnails');
const fromTop = document.querySelector('.header').offsetHeight + document.querySelector('.header').getBoundingClientRect().top;
if(thumbnails) thumbnails.style.top = `${fromTop - 1}px`;

// Announcement bar close fixes
const headerWrapper = document.querySelector('.header');
const closeButton = document.querySelector('.announcement-bar__close');
const elementsToChange = document.querySelectorAll('.from-top-will-change')

closeButton.addEventListener('click', event => {
  // Change top positioned elements
  if (elementsToChange.length) {
    elementsToChange.forEach(element => {
      element.style.top = `${headerWrapper.offsetHeight}px`;
    });
  }
});

// Size Guide
const openSizeGuide = document.querySelector('.product__open-size-guide');

if (openSizeGuide) {
  openSizeGuide.addEventListener('click', event => {
    event.preventDefault();
  });
}

// Product Form
customElements.define('product-form', class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartDrawer = document.querySelector('cart-drawer');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        this.cartDrawer.rerender(true);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
});